import { ApplicationLayout } from "./application-layout";

import type { FC } from "react";

export const GenerateLayout: FC = () => (
  <ApplicationLayout
    layout="content"
    slots={{ root: { props: { sx: { bgcolor: "neutral.100" } } } }}
  />
);
